import { ProtectedRoute } from "@/components/ProtectedRoute";
import { createFileRoute } from "@tanstack/react-router";
import { AdminHomePage } from "../../pages/admin/AdminHomePage";

const ProtectedAdminHomePage = () => {
  return (
    <ProtectedRoute>
      <AdminHomePage />
    </ProtectedRoute>
  );
};

export const Route = createFileRoute("/admin/")({
  component: ProtectedAdminHomePage,
});
